<template>
  <div>
    <div class="has-text-centered has-background-background  pdb-20px"
    v-if="!contact.tiersId">
      <div class="card-content" v-if="isEdit">
        <h1 class="title is-size-4">
        {{ $t('editionContact.messages.ajouterCustomer')}}
        </h1>
      </div>
    </div>
    <div v-else>
      <div class="columns" v-if="isEdit">
        <div class="column is-12">
          <qd-button
            class="is-pulled-right"
            type="is-addOrEdit"
            @click="addTiers">
                {{$t('editionContact.contactsTiers.table.addTiers')}}
          </qd-button>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <v-client-table
            :data="contactTiers"
            :columns="columns"
            :options="options">
              <template slot="tiersId" slot-scope="{ row, index }">
                <b-field v-if="isEdit">
                  <b-autocomplete
                    class="exception-input"
                    :value="row.nomCommercial"
                    :data="filteredTiers"
                    open-on-focus
                    field=nomCommercial
                    icon-right="magnify"
                    @typing="getFilteredTiers"
                    @select="updateTiers(index, $event)"
                    @focus="onFocus"
                    >
                  </b-autocomplete>
                </b-field>
                <div v-else>
                  {{ row.nomCommercial }}
                </div>
              </template>
              <template slot="delete" slot-scope="{ index }" v-if="isEdit">
                <a @click="deleteLine(index)">
                  <b-icon type="is-danger" icon="delete-forever" />
                </a>
              </template>
          </v-client-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import { getAll as getAllTiers } from '@/api/tiers/index';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import {
  TIERS_TYPE_CLIENT,
  TYPOLOGIE_ENSEIGNE,
  TYPOLOGIE_GROUPE,
  TYPOLOGIE_POINT_DE_VENTE,
} from '@/configuration/tiers/tiersConf';
import messageErreur from '@/services/general/messageErreur';

const societe = createNamespacedHelpers('societe');

export default {
  props: {
    contact: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      contactTiers: [],
      tiersEnfants: [],
      search: '',
    };
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    columns() {
      return this.isEdit ? ['tiersId', 'delete'] : ['tiersId'];
    },
    filteredTiers() {
      return cloneDeep(this.tiersEnfants)
        .filter(t => !this.contactTiers.some(tt => t.id === tt.id))
        .filter((item) => {
          return item.nomCommercial?.toLowerCase().includes(this.search.toLowerCase());
        });
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      texts.noResults = this.$i18n.t('editionContact.contactsTiers.table.noResults');
      return {
        sortIcon: SORT_ICON,
        headings: {
          tiersId: this.$t('editionContact.tabs.contactsTiers'),
          delete: '',
        },
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        sortable: [],
        columnsClasses: {
          delete: 'colonneSelected has-text-centered is-vcentered',
        },
      };
    },
  },
  methods: {
    updateOnContact() {
      this.$emit('updateContactsTiers', this.contactTiers);
    },
    addTiers() {
      this.contactTiers.push({
        nomCommercial: '',
        id: null,
      });
      this.updateOnContact();
    },
    updateTiers(index, value) {
      if (value) {
        this.contactTiers[index - 1].nomCommercial = value.nomCommercial;
        this.contactTiers[index - 1].id = value.id;
        this.updateOnContact();
      }
    },
    deleteLine(index) {
      this.contactTiers.splice(index - 1, 1);
      this.updateOnContact();
    },
    async loadTiersEnfants() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const tiers = (await getAllTiers({
          query: {
            societeId: this.societeActiveId,
            type: TIERS_TYPE_CLIENT,
            typologie: [TYPOLOGIE_POINT_DE_VENTE, TYPOLOGIE_ENSEIGNE, TYPOLOGIE_GROUPE],
            lienTiers: this.contact.tiersId,
          },
        })).data.result.items;
        this.tiersEnfants = tiers;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    getFilteredTiers: debounce(function setSearchText(text) {
      this.search = text;
    }, 300),
    onFocus(row) {
      this.search = row.srcElement.value;
    },
  },
  async mounted() {
    this.contactTiers = cloneDeep(this.contact.contactsTiers ?? []);
    if (this.isEdit) {
      await this.loadTiersEnfants();
    }
  },
};
</script>
